import { createFileRoute } from "@tanstack/react-router"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Separator } from "@/components/ui/separator"
import { useDocumentTitle } from "@/lib/useDocumentTitle"

const contactData = {
  mobileNr: "0170 4700820",
  telephoneNr: "05741 298338",
  name: "Martin Kupski",
  email: "martin@pianoservice-kupski.de",
  street: "Bergkämpe",
  houseNr: "6",
  city: "32312 Lübbecke",
  imgSrc: "/images/stimmen.jpeg",
}

export const Route = createFileRoute("/")({
  component: HomePage,
})

function HomePage() {
  useDocumentTitle("Pianoservice Kupski")
  const { telephoneNr, mobileNr, name, email, street, houseNr, imgSrc, city } =
    contactData

  return (
    <div className="flex flex-col justify-center items-center flex-1 py-8">
      <div className="flex justify-center text-center text-lg mx-8 mb-8">
        <p className="max-w-3xl font-serif font-bold">
          Klavierstimmungen &bull; Intonierung &bull; Beratung / Angebot &bull;
          Generalüberholung &bull; Mechanik &bull; Konzertdienst &bull; Kleine
          Reparaturen
        </p>
      </div>

      <Separator className="max-w-2xl mb-8 hidden lg:block" />

      <Card className="w-full max-w-5xl mx-4 overflow-hidden">
        <div className="flex flex-col lg:flex-row">
          <div className="relative w-full lg:w-1/2 h-80 lg:h-auto lg:min-h-[400px]">
            {imgSrc && (
              <img
                src={imgSrc}
                alt={name}
                className="absolute inset-0 w-full h-full object-cover"
              />
            )}
          </div>
          <div className="flex-1">
            <CardHeader>
              <CardTitle className="font-serif text-primary text-3xl">
                Kontakt
              </CardTitle>
            </CardHeader>
            <CardContent className="prose lg:prose-lg dark:prose-invert">
              <p>
                <b>Anschrift:</b>
                <br />
                <a
                  href={`http://maps.google.com/?q=Piano Service ${street} ${houseNr},${city}`}
                  className="hover:text-primary transition-colors"
                >
                  {name}
                  <br />
                  {street && street + " " + houseNr}
                  <br />
                  {city}
                </a>
              </p>
              <p>
                <b>Telefon:</b>
                <br />
                <a
                  href={`tel:${telephoneNr}`}
                  className="hover:text-primary transition-colors"
                >
                  {telephoneNr}
                </a>
              </p>
              <p>
                <b>Mobil:</b>
                <br />
                <a
                  href={`tel:${mobileNr}`}
                  className="hover:text-primary transition-colors"
                >
                  {mobileNr}
                </a>
              </p>
              <p>
                <b>E-Mail:</b>
                <br />
                <a
                  href={`mailto:${email}`}
                  className="hover:text-primary transition-colors"
                >
                  {email}
                </a>
              </p>
            </CardContent>
          </div>
        </div>
      </Card>

      <Separator className="max-w-2xl mt-8 hidden lg:block" />
    </div>
  )
}
